import React from 'react'

function TermsNotice() {
  return (
    <p className="ai-sign-in-modal__terms cgt-caption">
      By continuing I agree to the
      {' '}
      <a
        className="cgt-link-primary-accented"
        href="/pages/terms-and-conditions"
        target="_blank"
        rel="noopener noreferrer"
      >
        General Terms &amp; Conditions
      </a>
      {' '}
      and
      {' '}
      <a
        className="cgt-link-primary-accented"
        href="/pages/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy Policy.
      </a>
    </p>
  )
}

export default TermsNotice
